import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'siat-card-item',
  templateUrl: './card-item.component.html',
  styleUrls: ['./card-item.component.scss'],
   
  imports: [ CommonModule],
})
export class CardItemComponent {
  /**
   * The card icon input.
   */
  @Input()
  cardIcon: string;

  /**
   * The card label.
   */
  @Input()
  cardLabel: string;

  /**
   * The card item id.
   */
  @Input()
  cardId: number;

  /**
   * The card description.
   */
  @Input()
  cardTooltip: string;

  /**
   * Emits an event when clicking a card.
   */
  @Output()
  cardClicked = new EventEmitter();

  /**
   * Emits an event when clicking a delete button.
   */
  @Output()
  deleteButtonClicked = new EventEmitter();

  /**
   * Custom class
   */
  @Input()
  customClass: string;
}
